module.exports = __webpack_public_path__ + "static/media/icon-cross-circle_bold.995b2c79.svg";